import { createUseStyles } from 'react-jss'
import { white } from '../../../styles/colors'
import MediaQueries from '../../../styles/MediaQueries'

const useStyles = createUseStyles({
  overlay: {
    boxSizing: 'border-box',
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    fontWeight: 400,
    fontFamily: 'GothamRounded',
    color: white,
    padding: '40px',
    fontSize: '13.5px',
    lineHeight: '18px'
  },

  overlayText: {
    marginBottom: '8px',
    textAlign: 'center'
  },

  watermark: {
    maxWidth: '128px'
  },

  [MediaQueries.Tablet]: {
    overlay: {
      '& > *': {
        maxWidth: '456px'
      },
      fontSize: '15.5px'
    },
    overlayText: {
      marginBottom: '12px'
    }
  },

  [MediaQueries.LaptopSmall]: {
    overlay: {
      '& > *': {
        maxWidth: '510px'
      },
      fontSize: '16px'
    },
    overlayText: {
      marginBottom: '25px'
    }
  },

  [MediaQueries.Desktop]: {
    overlay: {
      '& > *': {
        maxWidth: '680px'
      },
      fontSize: '21px'
    },
    overlayText: {
      marginBottom: '33px'
    }
  }
})

export default useStyles
